import { Typography } from '@mui/material'

interface RangeLabelProps {
  from: number
  to?: number
  unit?: string
}

export const RangeLabel = ({ from, to, unit }: RangeLabelProps) => {
  const unitLabel = unit ? unit : 'units'

  if (to === undefined) {
    return (
      <Typography aria-label="tier-range" variant="p3Regular">
        From {from} {unitLabel}
      </Typography>
    )
  }

  return (
    <Typography aria-label="tier-range" variant="p3Regular">
      Between {from} - {to ?? '∞'} {unitLabel}
    </Typography>
  )
}
